module.exports = __webpack_public_path__ + "img/learning.815157b0.png";